import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContratoConfirmarInformacoesPage } from './contrato-confirmar-informacoes.page';

const routes: Routes = [{ path: '', component: ContratoConfirmarInformacoesPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContratoConfirmarInformacoesRoutingModule { }
